import createElement from '../../logical-components/createElement';
import '../scss/input.scss';
var buildField = function (inputConfig) {
    var label = inputConfig.label, labelInfo = inputConfig.labelInfo, id = inputConfig.id, defaultValue = inputConfig.defaultValue, placeholder = inputConfig.placeholder, onChange = inputConfig.onChange, type = inputConfig.type, onFocus = inputConfig.onFocus, outFocus = inputConfig.outFocus, onEnter = inputConfig.onEnter, _a = inputConfig.fieldType, fieldType = _a === void 0 ? 'input' : _a;
    var wrapper = createElement('div', [
        { type: 'class', value: '_msng-input-wrapper' },
    ]);
    if (fieldType === 'input') {
        wrapper.innerHTML = "\n            <label for='field-".concat(id, "'> ").concat(label, " ").concat(labelInfo ? "<span class=\"_msnlq-info\">i<span class=\"_msnlq-info-panel\">".concat(labelInfo, "</span></span>") : '', "</label>\n            <input autocomplete=\"off\" data-lpignore=\"true\" ").concat(type === 'date' ? 'type="date"' : '', " id='field-").concat(id, "' value='").concat(defaultValue || '', "' placeholder='").concat(placeholder, "'/>\n        ");
    }
    else {
        wrapper.innerHTML = "\n            <label for='field-".concat(id, "'> ").concat(label, " </label>\n            <textarea autocomplete=\"off\" data-lpignore=\"true\" ").concat(type === 'date' ? 'type="date"' : '', " id='field-").concat(id, "' value='").concat(defaultValue || '', "' placeholder='").concat(placeholder, "'> </textarea>\n        ");
    }
    // Apply event listener
    var input = fieldType === 'input'
        ? wrapper.querySelector('input')
        : wrapper.querySelector('textarea');
    input.addEventListener('input', function (event) {
        if (onChange) {
            onChange(event);
        }
    });
    input.addEventListener('focus', function () {
        if (onFocus) {
            onFocus();
        }
    });
    input.addEventListener('blur', function () {
        if (outFocus) {
            outFocus();
        }
    });
    input.addEventListener('keypress', function (e) {
        var keyboardEvent = e;
        if ((keyboardEvent === null || keyboardEvent === void 0 ? void 0 : keyboardEvent.key) && keyboardEvent.key === 'Enter') {
            keyboardEvent.preventDefault();
            onEnter();
        }
    });
    return wrapper;
};
export default buildField;
